import React, { memo, Fragment } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';

import vinImage from 'media/vin-popin-image.jpg';
import styles from './PopinVinInfo.module.scss';
const cx = classNames.bind(styles);

const PopinVinInfo = ({ labels }) => (
  <Fragment>
    <h3 className={cx('title')}>{labels.popinVinInfoTitle}</h3>
    <div className={cx('description')}>
      {labels.popinVinInfoDescription}
      <img src={vinImage} alt="" width="573" height="283" className={cx('img')} />
    </div>
  </Fragment>
);

PopinVinInfo.propTypes = {
  labels: object.isRequired,
};

export default memo(withLabels(PopinVinInfo));



// WEBPACK FOOTER //
// ./src/components/PopinVinInfo/PopinVinInfo.js